<template>
    <div class="apprentice-simple-card remove-bottom-card-margin">
        <div
            class="files"
            v-if="items.length">
            <design-2021-apprentice-data-table
                class="files-table"
                :fields="fields"
                :items="items"
                :filter-ignored-fields="ignoreFields">
                <template v-slot:options>
                    <b-button
                        class="btn-upload btn-add-file"
                        @click="showUploadFileModal"
                        variant="primary">
                        {{ $t('files.upload_new_file') }}
                    </b-button>
                </template>

                <template #cell(name)="row">
                    <b-button
                        class="btn-file-preview"
                        v-if="common.canPreviewFile(row.item.extension)"
                        variant="link"
                        @click="previewFile(row.item)">
                        {{ row.item.name }}
                    </b-button>

                    <div
                        class="file-name"
                        v-else>
                        {{ row.item.name }}
                    </div>
                </template>

                <template v-slot:cell(accessible)="row">
                    <b-badge variant="primary"
                        >{{ row.item.accessible === 1 ? $t('files.teachers') : $t('files.everyone') }}
                    </b-badge>
                </template>

                <template v-slot:cell(actions)="row">
                    <div class="management-actions">
                        <b-button
                            class="btn-download btn-file-download"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('common.download')"
                            :href="row.item.public_path"
                            target="_blank">
                        </b-button>

                        <b-button
                            class="btn-file-magnifying-glass"
                            v-if="row.item.extension === 'docx' && !isStudent && row.item.project_id"
                            v-b-modal="'paper-item-plagiarism-modal-' + row.item.id"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('files.view_plagiarism_reports')">
                        </b-button>

                        <design-2021-file-plagiarism-modal-component :file-id="row.item.id">
                        </design-2021-file-plagiarism-modal-component>

                        <b-button
                            class="btn-remove btn-remove-file"
                            v-if="row.item.project_id"
                            v-b-tooltip.hover
                            variant="danger-icon-only"
                            :title="$t('common.delete')"
                            @click="onRemove(row.item.id)">
                        </b-button>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </div>

        <div
            class="not-found with-header"
            v-else>
            <div class="header">
                <b-button
                    class="btn-upload btn-file-upload"
                    @click="showUploadFileModal"
                    variant="primary">
                    {{ $t('files.upload_new_file') }}
                </b-button>
            </div>

            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>

            <div class="alert-notice">{{ $t('files.no_file_uploaded') }}</div>
        </div>

        <design-2021-file-upload-modal-component :project-id="projectId"></design-2021-file-upload-modal-component>
    </div>
</template>

<script>
import { FilesBus } from '../../app';
import Design2021FileUploadModalComponent from './design-2021-file-upload-modal-component.vue';

export default {
    components: { Design2021FileUploadModalComponent },

    props: ['userId', 'projectId', 'isStudent'],

    name: 'design-2021-files-table-component',

    data() {
        return {
            list: [],
            id: null,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.title'),
                    sortable: true,
                },
                {
                    key: 'uploadedBy',
                    label: this.$t('files.through'),
                },
                {
                    key: 'accessible',
                    label: this.$t('files.for'),
                },
                {
                    key: 'date',
                    label: this.$t('files.date'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            items: [],
            ignoreFields: ['actions', 'public_path'],
        };
    },

    methods: {
        onRemove(id) {
            this.alert
                .confirm(this.$t('files.delete_file'), this.$t('files.are_you_sure_you_want_to_delete_this_file'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.removeFile(id);
                });
        },

        removeFile(id) {
            let uri = this.routes.baseUrl() + '/files/delete/' + id;

            axios
                .delete(uri)
                .then(() => {
                    this.alert.success(this.$t('files.file_successfully_deleted'));
                    this.fetchData();
                })
                .catch((error) => {
                    this.alert.ajaxError(error);
                });
        },

        fetchData() {
            //todo url in web

            this.axios.get(this.routes.baseUrl() + '/files/getFileList/' + this.projectId).then(
                (response) => {
                    let data = response.data;
                    this.list = [];
                    let files_size_tmp = 0;

                    if (data) {
                        data.files.forEach((value, index) => {
                            value.font_type = this.getFontType(value.extention);
                            this.list.push(value);
                            files_size_tmp = files_size_tmp + value.size;
                        });
                    }

                    this.items = this.list.map((item) => {
                        return {
                            id: item.id,
                            name: item.name,
                            uploadedBy: item.user ? item.user.full_name : this.$t('files.unfamiliar'),
                            accessible: item.teacher_only,
                            date: this.$options.filters.date_time_om_year(item.created_at),
                            project_id: item.project_id,
                            path: item.path,
                            public_path: item.public_path,
                            extension: item.extension,
                            plag_url: item.plag_url,
                            plag_has: item.plag_has,
                            plag_progress: item.plag_progress,
                        };
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );

            // let uri = this.routes.baseUrl() + '/files/getFileList/' + this.projectId;
            //
            // axios.get(uri).then((response) => {
            //     let data = response.data;
            //     this.list = [];
            //     let files_size_tmp = 0;
            //
            //     if (data) {
            //         data.files.forEach((value, index) => {
            //             value.font_type = this.getFontType(value.extention);
            //             this.list.push(value);
            //             files_size_tmp = files_size_tmp + value.size;
            //         });
            //     }
            //
            //     this.items = this.list.map((item) => {
            //         return {
            //             id: item.id,
            //             name: item.name,
            //             uploadedBy: item.user ? item.user.full_name : this.$t('files.unfamiliar'),
            //             accessible: item.teacher_only,
            //             date: this.$options.filters.date_time_om_year(item.created_at),
            //             project_id: item.project_id,
            //             path: item.path,
            //             public_path: item.public_path,
            //             extension: item.extension,
            //             plag_url: item.plag_url,
            //             plag_has: item.plag_has,
            //             plag_progress: item.plag_progress,
            //         };
            //     });
            // });
        },

        getFontType(extension) {
            if (extension === 'docx' || extension === 'doc') {
                return 'far fa-file-word fa-2x';
            }

            return 'far fa-file fa-2x';
        },

        showUploadFileModal() {
            this.$bvModal.show('file-upload-modal');
        },

        previewFile(file) {
            this.$root.$refs.filePreview.show(file);
        },
    },

    created() {
        this.fetchData();
        FilesBus.$on('pushData', (data) => {
            this.fetchData();
        });
    },
};
</script>

<style scoped lang="scss">
::v-deep .files {
    .btn-file-download {
        display: flex;
        align-items: center;
    }
}

.file-actions,
.file-plagiarism-reports {
    display: flex;
    align-items: center;

    .btn:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.files-table ::v-deep {
    .apprentice-data-table {
        .btn-file-preview.btn-file-preview {
            font-size: $default-font-size;
            line-height: 1;
        }
    }
}
</style>
